import { useEffect, useRef } from "react";

export function useDebounce() {
  const timer = useRef<ReturnType<typeof setTimeout>>();

  function debounce(function_: () => void, delay: number) {
    clearTimeout(timer.current);
    timer.current = setTimeout(function_, delay);
  }

  useEffect(() => () => clearTimeout(timer.current), []);

  return { debounce };
}
